import LocationPinIcon from '@mui/icons-material/LocationPin';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import PhoneIcon from '@mui/icons-material/Phone';
import HomePage from './HomePage/HomePage';
import LocationPage from './LocationPage/LocationPage';
import MenuPage from './MenuPage/MenuPage';
import ContactPage from './ContactPage/ContactPage';

export const pages = [
    {label:'Αρχική',     path:'/',         navicon:null,                   component:<HomePage />     },
    {label:'Η Τοποθεσία μας', path:'/location', navicon:<LocationPinIcon/>,     component:<LocationPage /> },
    {label:'Το Μενού μας',     path:'/menu',     navicon:<RestaurantMenuIcon/>,  component:<MenuPage />     },
    {label:'Επικοινωνία',  path:'/contact',  navicon:<PhoneIcon/>,           component:<ContactPage />  },
]